import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Card,
  CardBody,
  CardImg,
  Button,
  CardTitle,
  CardText,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import Loading from "../../hoc/Loading/Loading";
import axios from "../../axios";
import * as actionCreators from "../../modules/actions/index";
import * as url from "../../utils/url";
import {
  dashboardChartSize,
  uploadPreview,
  checkUploadType,
  extractAndDecodeFilename,
} from "../../utils/constants";
import moment from "moment";
import { BiFile } from "react-icons/bi";

class UploadFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: [],
      isUploadFiles: false,
      isSubmit: false,
      setImagesPreview:
        this.props.attachments && this.props.attachments.length > 0
          ? this.props.attachments
          : [],
      rejectedFiles: [],
      isExceedLimit: false,
      // attachments: this.props.task_copy.attachments
    };
  }

  fileSelectedHandler = (e) => {
    let fileLength = e.target.files.length;
    let { setImagesPreview } = this.state;
    let { limit } = this.props;
    // let allowedLength=

    if (e.target.files) {
      let arr = [];
      let fileArr = Array.from(e.target.files).map((file, idx) => {
        // console.log('file: ', file)
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          datetime: Date.now().toString(),
          // blob: URL.createObjectURL(file),
          preview: URL.createObjectURL(file),
          isAccepted: checkUploadType(file.type),
        };
        return uploadPreview(obj);
      });

      let acceptedFiles = fileArr
        .filter((e) => e.isAccepted == true)
        .map((e) => {
          delete e.isAccepted;
          return e;
        });
      let rejectedFiles = fileArr.filter((e) => e.isAccepted == false);
      let allUploads = acceptedFiles.concat(rejectedFiles);

      setImagesPreview = setImagesPreview.concat(acceptedFiles);
      console.log(limit, "----setImagesPreview --- ", setImagesPreview);
      if (!isNaN(limit)) {
        if (setImagesPreview.length < limit) {
          this.setState((prevState) => ({
            setImagesPreview,
            isExceedLimit: false,
            rejectedFiles: prevState.rejectedFiles.concat(rejectedFiles),
          }));
        } else {
          this.setState((prevState) => ({ isExceedLimit: true }));
        }
      } else {
        this.setState((prevState) => ({
          setImagesPreview,
          isExceedLimit: false,
          rejectedFiles: prevState.rejectedFiles.concat(rejectedFiles),
        }));
      }

      if (!isNaN(limit) && setImagesPreview.length < limit) {
        this.props.setUploads(setImagesPreview);
      } else {
        this.props.setUploads(setImagesPreview);
      }

      Array.from(e.target.files).map((file) => URL.revokeObjectURL(file));
    }
  };

  removeImage = (photo,idx) => {
    console.log(photo);
    let { setImagesPreview } = this.state;
    let { old_attachment } = this.props;
    let { preview } = photo;


    if (preview == null || !preview) {
      preview = photo.url ? photo.url : photo;
    }

    console.log(setImagesPreview)


    setImagesPreview.map((el) => URL.revokeObjectURL(el.file));
       let result = setImagesPreview
       result.splice(idx,1)
    // let result = setImagesPreview.filter(e=>(e.preview!=preview) && (e.url!=preview) && (e!=preview))
    // let result = setImagesPreview.filter((e) => {
    //   console.log(e,preview)
    //   if (e.preview) {
    //     return e.preview != preview;
    //   } else if (e.url) {
    //    return e.url != preview;
    //   } else {
    //     return e != preview;
    //   }
    // });

    console.log(result);

    URL.revokeObjectURL(preview);
    URL.revokeObjectURL(photo.file);
    this.setState({ setImagesPreview: result });
    this.props.setUploads(result);

    if (old_attachment && old_attachment.length > 0) {
      if (old_attachment == preview) {
        this.props.removeOldAttachment();
      }
    }
  };

  renderUploadPreview = (source) => {
    let { rejectedFiles } = this.state;

    return source.map((photo, idx) => {
      let { preview, size } = photo;
      preview = preview != null && preview != undefined ? preview : photo.url||photo;
      let mb = 1024 * 1024;
      let file_size = size ?
        size >= mb
          ? `${(size / mb).toFixed(2)}mb`
          : `${(size / 1024).toFixed(2)}kb`:"";
      photo = typeof photo == "string" ? photo :{ ...photo, preview, idx }
  
      return (
        <span
          key={idx}
          className={
            photo.isAccepted == false
              ? "taskUploadPreviewImg rejectedFilesContainer"
              : "taskUploadPreviewImg"
          }
        >
         {preview ?  <img src={preview} className="fileUploadSize" /> : <BiFile /> } 
          {/* {photo.isMsIcon?
        <div classaName="imageUploadBlobSrc">
            <iframe src={preview} class="imgBlobSrc" scrolling="no" scroll="no" />
        </div>
        :
        <img src={preview}  className="fileUploadSize"/>
        } */}

          <span
            key={preview + idx}
            onClick={() => this.removeImage(photo,idx)}
            className="removeTaskUpload"
          >
            <span className="flaticon-trash" />
          </span>
          <div className="previewTaskImageText">
            <span className="previewTaskImageTitle">{ photo ? photo.name || extractAndDecodeFilename(photo)  :"File"}</span>
            <span className="previewTaskImageTitle">{file_size}</span>
            {/* {photo.isAccepted==false?
            <span className="previewUploadFileError">
              The following file will not be uploaded because of its file type
            </span>
            :null} */}
          </div>
        </span>
      );
    });
  };

  handleClick = (event) => {
    const { target = {} } = event || {};
    target.value = "";
  };

  closeActionsModal = () => {
    this.setState({ setImagesPreview: [], rejectedFiles: [] });
    this.props.isUploadModal({ isUploadFiles: false });
  };

  render() {
    let {
      setImagesPreview,
      isUploadFiles,
      rejectedFiles,
      isSubmit,
    } = this.state;
    return (
      //    <Modal isOpen={isUploadFiles} className="uploadFilesModalContainer">
      //    <ModalHeader className="dashboardHeader" charCode="X"
      //       toggle={this.closeActionsModal} >
      //       <div className="dashboardModalTitle"> Upload Files</div>
      //     </ModalHeader>

      //           <ModalBody className="taskUploadFileModal">

      <span>
        <div>
          {rejectedFiles && rejectedFiles.length > 0 ? (
            <div className="rejectedFilesContainer">
              <span className="">
                The following file(s) will not be uploaded because of the file
                type:
              </span>
              &nbsp;
              {rejectedFiles.map((e, idx) => {
                let name =
                  idx == rejectedFiles.length - 1
                    ? e.name + "."
                    : e.name + ", ";
                return name;
              })}
            </div>
          ) : null}

          <div>
            {setImagesPreview && setImagesPreview.length > 0 ? (
              <div className="taskUploadPreviewContainer mb0">
                {this.renderUploadPreview(setImagesPreview)}
              </div>
            ) : null}
          </div>
        </div>

        <div className="singleTaskUploadModalBtn">
          <label
            htmlFor="profile-pic-file-input"
            style={{ marginBottom: "0px" }}
          >
            <span
              className={`actionsByStatus ${
                this.props.isToolkit
                  ? "upload_file_toolkit"
                  : "singleTaskUpload"
              } ${isSubmit ? "opacity40" : ""}`}
            >
              <span className="flaticon-upload" />
              Choose Files
            </span>
          </label>
          <input
            id="profile-pic-file-input"
            onClick={!isSubmit ? this.handleClick : null}
            onChange={this.fileSelectedHandler}
            type="file"
            multiple
          />
        </div>

        {/* <Button className={setImagesPreview&&setImagesPreview.length>0 && !isSubmit?"uploadFilesBtn":'opacity40 uploadFilesBtn'}
                              onClick={setImagesPreview && setImagesPreview.length>0 && !isSubmit? ()=>this.uploadAttachments():null} 
                              >
                              <span className="">
                                Upload
                                <span className="ml10 flaticon-tick"></span></span>
                            </Button>
                            <Button className={`cancelFilesBtn ${isSubmit?'opacity40':''}`} onClick={!isSubmit? ()=>this.closeActionsModal():null}>
                              <span className="profile-modal-cancel-btn-txt">Cancel</span>
                            </Button> */}
        {/* </ModalBody>
                  </Modal> */}
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

// export default LinkedCharts;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(UploadFiles, axios)));
